<template>
  <v-dialog v-model="isZoomed" scrollable>
    <v-card>
      <v-card-text class="pa-0">
        <v-img
          :src="src"
          contain
        />
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-btn class="pa-6" block color="primary" text @click="isZoomed = false">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>

    <template
      v-for="(_, name) in $scopedSlots"
      #[name]="slotProps = {}"
    >
      <slot
        v-bind="slotProps"
        :name="name"
      />
    </template>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import AppLoading from './ui/AppLoading.vue';

defineProps({
    src: {
      type: String,
      required: true
    }
})

const isZoomed = ref(false)
</script>
